const errorTranslations = {
  'en-US': {
    404: {
      pageTitle: '404 - Page Not Found!',
      title: '404 Page Not FOUND!',
      detail: 'Sorry, Couldn’t find the page you are looking for!',
      button: 'Return Home',
    },
    500: {
      pageTitle: '500 - Something Went Wrong!',
      title: '500 Something went wrong!',
      detail: 'Sorry, there was a problem while serving your request',
      button: 'Return Home',
    },
  },
}

export default errorTranslations
